import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import mainlogo from "../../assets/img/tiq8-Logo-white.png";
import { BsEyeFill, BsEyeSlashFill } from "react-icons/bs";
import moment from "moment";
import { FaCheck, FaSignInAlt } from "react-icons/fa";
import { API_DOMAIN, GlobalConstants } from "../../utils/GlobalConst";
import { PASSWORD_REGEX } from "../../utils/Validation";
import axios from "axios";
import { toast } from "react-toastify";
import PasswordChecklist from "react-password-checklist";
import { GoDotFill } from "react-icons/go";

const xpath = require("xpath");
const dom = require("xmldom").DOMParser;

function SetupAccount() {
  const location = useLocation(); // Get the full URL location
  const navigate = useNavigate();
  const urlParams = new URLSearchParams(location.search);
  const Key = urlParams.get("key");
  console.log(Key);
  const [passsword, setPasssword] = useState("");
  const [CPassword, setCPassword] = useState("");
  const [passErr, setPassErr] = useState("");
  const [CPassErr, setCPassErr] = useState("");
  const [passVisibility, setPassVisibility] = useState(false);
  const [CPassVisibility, setCPassVisibility] = useState(false);

  const [login_title, setLogin_title] = useState(
    "The Easiest Way to Create Events and Sell More Tickets Online"
  );
  const [text_ph_pass, setText_ph_pass] = useState("Enter Password");
  const [text_password, setText_password] = useState("Password");
  const [text_confirmpass, setText_confirmpass] = useState("Confirm Password");
  const [text_ph_confirmPass, setText_ph_confirmPass] = useState(
    "Enter Confirm Password"
  );
  const [text_rightsReserved, setText_rightsReserved] = useState(
    "TiQ8 Inc. All rights reserved"
  );
  const [text_err_pass, setText_err_pass] = useState("Please Enter Password");
  const [text_err_strongPass, setText_err_strongPass] = useState(
    "Please Enter Strong Password"
  );
  const [text_err_confirmPass, setText_err_confirmPass] = useState(
    "Please Enter Confirm Password"
  );
  const [text_err_pass_match, setText_err_pass_match] = useState(
    "Password & Confirm Password Don't Match"
  );
  const [pass_minLength_Err, setPass_minLength_Err] = useState(
    "Password has at least 8 characters."
  );
  const [pass_specialChar_Err, setPass_specialChar_Err] = useState(
    "Password has special characters."
  );
  const [pass_number_Err, setPass_number_Err] = useState(
    "Password has a number."
  );
  const [pass_capital_Err, setPass_capital_Err] = useState(
    "Password has a capital letter."
  );
  const changeVisibility = (e) => {
    e.preventDefault();
    setPassVisibility(!passVisibility);
  };
  const changeCVisibility = (e) => {
    e.preventDefault();
    setCPassVisibility(!CPassVisibility);
  };

  const ValidationHandler = () => {
    var isValid = true;

    if (!passsword) {
      isValid = false;
      setPassErr(<>* {text_err_pass}!</>);
    }
    if (passsword && !PASSWORD_REGEX.test(passsword) === true) {
      isValid = false;
      setPassErr(<>*{text_err_strongPass}</>);
    }
    if (!CPassword) {
      isValid = false;
      setCPassErr(<>* {text_err_confirmPass}!</>);
    }
    if (passsword !== CPassword) {
      isValid = false;
      setCPassErr(<>* {text_err_pass_match}!</>);
    }
    return isValid;
  };

  useEffect(() => {
    try {
      SetLanguageText();
    } catch (err) {
      console.log("" + err);
    }
  }, []);
  const SetLanguageText = () => {
    try {
      var xml = localStorage.getItem(GlobalConstants.session_lang_xml);
      var doc = new dom().parseFromString(xml);
      setText_password(
        xpath.select1("/resources/string[@name='text_password']", doc)
          .firstChild.data
      );
      setText_confirmpass(
        xpath.select1("/resources/string[@name='text_confirmpass']", doc)
          .firstChild.data
      );
      setText_ph_pass(
        xpath.select1("/resources/string[@name='text_ph_pass']", doc).firstChild
          .data
      );
      setText_ph_confirmPass(
        xpath.select1("/resources/string[@name='text_ph_confirmPass']", doc)
          .firstChild.data
      );
      setText_rightsReserved(
        xpath.select1("/resources/string[@name='text_rightsReserved']", doc)
          .firstChild.data
      );
      setText_err_pass(
        xpath.select1("/resources/string[@name='text_err_pass']", doc)
          .firstChild.data
      );
      setText_err_strongPass(
        xpath.select1("/resources/string[@name='text_err_strongPass']", doc)
          .firstChild.data
      );
      setText_err_confirmPass(
        xpath.select1("/resources/string[@name='text_err_confirmPass']", doc)
          .firstChild.data
      );
      setText_err_pass_match(
        xpath.select1("/resources/string[@name='text_err_pass_match']", doc)
          .firstChild.data
      );
      setPass_minLength_Err(
        xpath.select1("/resources/string[@name='pass_minLength_Err']", doc)
          .firstChild.data
      );
      setPass_specialChar_Err(
        xpath.select1("/resources/string[@name='pass_specialChar_Err']", doc)
          .firstChild.data
      );
      setPass_number_Err(
        xpath.select1("/resources/string[@name='pass_number_Err']", doc)
          .firstChild.data
      );
      setPass_capital_Err(
        xpath.select1("/resources/string[@name='pass_capital_Err']", doc)
          .firstChild.data
      );
    } catch (ert) {}
  };
  const setupAccount = () => {
    if (ValidationHandler) {
      var API_URL =
        API_DOMAIN + `user/verifyguestlink?key=${Key}&password=${passsword}`;
      axios
        .get(API_URL)
        .then(function (response) {
          console.log("Account Updated ", response);
          if (response.data.message === "password reset successfully") {
            toast.success("Account Setup Done Successfully!");
            setTimeout(() => {
              navigate("/signin");
            }, 2000);
          }
        })
        .catch(function (error) {
          toast.error(error.response.data.message);
        })
        .then(function () {});
    }
  };
  return (
    <>
      <div className="form-wrapper" id="otherPages">
        <div className="app-form">
          <div className="app-form-sidebar">
            <Link to="/">
              <div className="sidebar-sign-logo">
                <img src={mainlogo} alt="" className="side-logo-outerPage" />
              </div>
            </Link>
            <div className="sign_sidebar_text">
              <h1>{login_title}</h1>
            </div>
          </div>
          <div className="app-form-content">
            <div className="container mt-5">
              <div className="row justify-content-center mt-3">
                <div className="col-lg-10 col-md-10">
                  <div className="app-top-items">
                    <Link to="/">
                      <div className="sign-logo" id="logo">
                        <img src={mainlogo} alt="" />
                        <img className="logo-inverse" src={mainlogo} alt="" />
                      </div>
                    </Link>
                    {/* <div className="app-top-right-link">
                      {text_newtotiq8}?
                      <Link className="sidebar-register-link" to="/signup">
                        {text_signup}
                      </Link>
                    </div> */}
                  </div>
                </div>
                <div className="col-xl-5 col-lg-6 col-md-7">
                  <div className="registration">
                    <div>
                      <h2 className="registration-title">
                        Setup Account in to TiQ
                      </h2>

                      <div className="form-group mt-5">
                        <div className="field-password">
                          <label className="form-label">
                            {text_password}
                            <span className="starsty">*</span>
                          </label>
                        </div>
                        <div className="loc-group position-relative">
                          <input
                            className="form-control h_50"
                            type={passVisibility ? "text" : "password"}
                            placeholder={text_ph_pass}
                            onChange={(e) => [
                              setPasssword(e.target.value),
                              setPassErr(""),
                            ]}
                          />
                          <span className="pass-show-eye">
                            <button
                              className="reg-eye"
                              onClick={(e) => changeVisibility(e)}
                            >
                              {passVisibility === true ? (
                                <BsEyeFill className="showpassnight" />
                              ) : (
                                <BsEyeSlashFill className="showpassnight" />
                              )}
                            </button>
                          </span>
                        </div>
                        <span className="validation-err">{passErr}</span>
                        <PasswordChecklist
                          rules={[
                            "minLength",
                            "specialChar",
                            "number",
                            "capital",
                          ]}
                          minLength={8}
                          value={passsword}
                          messages={{
                            minLength: <> {pass_minLength_Err}</>,
                            specialChar: <>{pass_specialChar_Err}</>,
                            number: <>{pass_number_Err}</>,
                            capital: <>{pass_capital_Err}</>,
                          }}
                          iconComponents={{
                            ValidIcon: (
                              <FaCheck
                                style={{
                                  color: "green",
                                  marginRight: "7px",
                                }}
                              />
                            ),
                            InvalidIcon: (
                              <GoDotFill style={{ marginRight: "7px" }} />
                            ),
                          }}
                        />
                      </div>
                      <div className="form-group mt-4">
                        <div className="field-password">
                          <label className="form-label">
                            {text_confirmpass}
                            <span className="starsty">*</span>
                          </label>
                        </div>
                        <div className="loc-group position-relative">
                          <input
                            className="form-control h_50"
                            type={CPassVisibility ? "text" : "password"}
                            placeholder={text_ph_confirmPass}
                            onChange={(e) => [
                              setCPassword(e.target.value),
                              setCPassErr(""),
                            ]}
                          />
                          <span className="pass-show-eye">
                            <button
                              className="reg-eye"
                              onClick={(e) => changeCVisibility(e)}
                            >
                              {CPassVisibility === true ? (
                                <BsEyeFill className="showpassnight" />
                              ) : (
                                <BsEyeSlashFill className="showpassnight" />
                              )}
                            </button>
                          </span>
                        </div>
                        <span className="starsty">{CPassErr}</span>
                      </div>

                      <button
                        className="main-btn btn-hover w-100 mt-4"
                        type="button"
                        onClick={setupAccount}
                        // disabled={loginBtn ? true : false}
                      >
                        Save <FaSignInAlt />
                      </button>
                      <b>
                        {" "}
                        <center>
                          <span className="validation-err mt-2">
                            {/* {loginErr} */}
                          </span>
                        </center>
                      </b>
                    </div>
                    {/* <div className="new-sign-link">
                      {text_newtotiq8}?
                      <Link className="signup-link" to="/signup">
                        {text_signup}
                      </Link>
                    </div> */}
                  </div>
                </div>
              </div>
            </div>
            <div className="copyright-footer">
              © {moment(new Date()).format("YYYY")}, {text_rightsReserved}.
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default SetupAccount;
